Application.Wordmark.Loading = {
    ui: {
        container: '.step-loading_wordmark'
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        this.cycle();

    },
    cycle: function(){

        var self = this;

        this.check(function(){
            setTimeout(function(){
                self.cycle();
            }, 2000);
        });

    },
    check: function(callback){

        $.get(link.processed, {
            uid: uid
        }, function(){
            jQuery.nette.success.apply(this, arguments);
            if (typeof callback === 'function'){
                callback();
            }
        });
    }
};